// Types
import type { SystemConfigProps } from '@/types/config/system'

// Utils
import resolvePortFromAPIUrl from '@/utils/api/resolve-port-from-api-url'

const systemAPIUrl = process.env.SYSTEM_API_URL || process.env.API_URL || 'https://api.rateup.ir/api'
const systemPort = Number(process.env.SYSTEM_PORT || process.env.SYSTEM_DESKTOP_PORT || resolvePortFromAPIUrl(systemAPIUrl) || 7607)

const SystemConfig: SystemConfigProps = {
	isDesktop: process.env.SYSTEM_DESKTOP === 'true',
	isMobile: process.env.SYSTEM_MOBILE === 'true',
	apiUrl: systemAPIUrl,
	port: systemPort,
	version: process.env.APP_VERSION || '0.0.0',
	platform: process.env.SYSTEM_DESKTOP === 'true' ? 'desktop' : process.env.SYSTEM_MOBILE === 'true' ? 'android' : 'desktop',
	defaultMode: 'automatic',
	servers: {
		main: {
			apiUrl: 'https://api.rateup.ir/api',
			port: 443
		},
		test: {
			apiUrl: 'https://test-api.rateup.ir/api',
			port: 443
		},
		manual: {
			apiUrl: process.env.SYSTEM_MANUAL_API_URL || process.env.SYSTEM_MOBILE_MANUAL_API_URL || '',
			port: Number(process.env.SYSTEM_MANUAL_PORT || process.env.SYSTEM_MOBILE_MANUAL_PORT || 7607)
		}
	},
	get isActive(): boolean {
		return (this.isDesktop || this.isMobile) ?? false
	}
}

export default SystemConfig
